export const getNetPrice = ({ basePrice = 0, discount: { breakdown = [] } = {} } = {}) =>
  basePrice - breakdown.reduce((total, { value = 0 } = {}) => total + value, 0);
